import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { TakataRecallService } from '../../takata-recall/takata-recall.service';
import { VideosService } from '../../videos/videos.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { APP_SETTINGS } from '@services';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { NoiseCatalogService } from '../noise-catalog.service';
import { NgIf, NgStyle, NgFor, DatePipe } from '@angular/common';
import { NoiseCatalogShareContentComponent } from '../../noise-catalog-share-content/noise-catalog-share-content.component';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-noise-catalog-playback',
    templateUrl: './noise-catalog-playback.component.html',
    styleUrls: ['./noise-catalog-playback.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgStyle,
        NgFor,
        RouterLink,
        NoiseCatalogShareContentComponent,
        DatePipe,
        HighlightSearchPipe,
    ],
})
export class NoiseCatalogPlaybackComponent implements OnInit, OnDestroy {

  public vimeoBaseUrl = 'https://player.vimeo.com/video/';
  public vimeoSafeUrl: SafeResourceUrl;
  public noiseCatalogList: any;
  public screenWidth: any;
  public currentNoiseCatalog: any;
  public likeOrDislikeNoiseCatalog: string;
  public noiseCatalogLiked = false;
  public noiseCatalogDisliked = false;
  private subscription: ISubscription[];
  public isNoiseCatalogWatchlisted: boolean;
  public showSpinner = false;
  private isPlayAll = false;
  private isWatchlist = false;
  private watchlist;
  private currentNoiseCatalogIndex = 0;
  public toggleAutoplay = false;
  public noisecatalogFile = '';
  public noisecatalogshareContentObject = {};
  public search4channel;
  //api: VgAPI;

  APP_SETTINGS: any;
  public videoThumbnail = APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail : APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  private username: string;
  public dateFormat: string;

  constructor(public sanitizer: DomSanitizer, private videoService: VideosService,
    private noiseCatalogService: NoiseCatalogService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private takataRecallService: TakataRecallService,
    private utilityService: UtilityService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    //private toastService: ToastConfigService
    private toastService: ToastrService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService
  ) {
    //this.config = this.toastService.config;
    this.screenWidth = this.utilityService.getScreenWidth();
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    this.subscription = [];
    this.noiseCatalogList = [];
    this.subscription.push(this.route.queryParams.subscribe(params => {
      // tslint:disable-next-line:quotemark
      this.isWatchlist = params['watchlist'] === "true" ? true : false;
      this.spinnerService.show('bmwSpinner');
      if (this.isWatchlist) {
        // tslint:disable-next-line:quotemark
        this.isPlayAll = params['playAll'] === "true" ? true : false;
        this.noiseCatalogService.getUsersWatchlist(this.username).subscribe(value => {
          this.spinnerService.hide('bmwSpinner');
          this.noiseCatalogList = value;
          const noisecatalogId = +params['noisecatalog'] || this.noiseCatalogList[0]['noiseCatalogId'];
          this.currentNoiseCatalogIndex = this.noiseCatalogList.findIndex(noisecatalog => noisecatalog.noiseCatalogId === noisecatalogId);
          this.currentNoiseCatalog = this.noiseCatalogList.find(noisecatalog => noisecatalog.noiseCatalogId === noisecatalogId);
          this.noisecatalogFile = this.vimeoBaseUrl + this.currentNoiseCatalog.noisecatalogFileName;
          this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.noisecatalogFile);
          //Analytics Call
          if (APP_SETTINGS.isAdmin === 'true') {
            this.analyticsCallAdminDocumentAttachmenttrack('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, this.noisecatalogFile, this.authService.getUserName());
          }
          else if (APP_SETTINGS.isExternal === 'true') {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsCallExternalDocumentAttachmentTrack('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, this.noisecatalogFile, userData['address1'], userData['city'], userData['state'], userData['Zipcode']);
            });
          }
          else {
            this.analyticsCall('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, this.noisecatalogFile);
          }
          this.applyUserPreferences();
        }, error => this.spinnerService.hide('bmwSpinner'));
      } else {

        const channelNumber = params['mainGroup'];
        const vimeoID = params['vimeoID'];
        if (vimeoID && vimeoID != null) {
          this.spinnerService.hide('bmwSpinner');
          this.noisecatalogFile = this.vimeoBaseUrl + params['vimeoID'];
          this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.noisecatalogFile);
          // this api also adds noisecatalog to the history list
          this.noiseCatalogService.postNoiseCatalogViews(this.username, params['noisecatalog']).subscribe(value => {});
        }

        this.noiseCatalogService.getNoiseCatalogsFromMaingroup(channelNumber).subscribe(value => {
          setTimeout(() => {
            this.spinnerService.hide('bmwSpinner');
          }, 5000);

          this.noiseCatalogList = value.noiseCatalogList;

          let noisecatalogId = +params['noisecatalog'];

          this.currentNoiseCatalog = this.noiseCatalogList.find(noisecatalog => noisecatalog.noiseCatalogId === noisecatalogId);

          if (!vimeoID || vimeoID == null) {

            this.noisecatalogFile = this.vimeoBaseUrl + this.currentNoiseCatalog.noisecatalogFileName;
            this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.noisecatalogFile);
          }
          //Analytics Call
          if (APP_SETTINGS.isAdmin === 'true') {
            this.analyticsCallAdminDocumentAttachmenttrack('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, this.noisecatalogFile, this.authService.getUserName());
          }
          else {
            this.analyticsCall('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, this.noisecatalogFile);
          }
          if (APP_SETTINGS.isExternal === 'true') {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsCallExternalDocumentAttachmentTrack('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, this.noisecatalogFile, userData['address1'], userData['city'], userData['state'], userData['Zipcode']);
            });
          }
          if (APP_SETTINGS.isDealer === 'true') {
            this.analyticsService.trackDealerContentTypeLocation('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
              APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
          }
          //this.noisecatalogFile = 'noisecatalog_files/' + this.currentNoiseCatalog.noisecatalogFileName; old code
          this.changeDetector.detectChanges();
          this.applyUserPreferences();
        }, error => this.spinnerService.hide('bmwSpinner'));

      }
    }));
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));
  }
  noisecatalogshareContent(noiseCatalogId, type, mainGroup, noiseCatalogDisplayNumber) {
    this.noisecatalogshareContentObject = {
      noiseCatalogId: noiseCatalogId,
      type: type,
      mainGroup: mainGroup,
      noiseCatalogDisplayNumber: noiseCatalogDisplayNumber
    };
  }

  applyUserPreferences() {
    this.toggleLikeOrDislikeNoiseCatalog();
    this.noiseCatalogService.getUsersWatchlist(this.username).subscribe(data => {
      this.watchlist = data;
      this.isNoiseCatalogWatchlisted = this.watchlist.some(noisecatalog => noisecatalog.noiseCatalogId === this.currentNoiseCatalog.noiseCatalogId);
    }, error => this.spinnerService.hide('bmwSpinner'));
    this.changeDetector.detectChanges();
  }

  analyticsCall(contentType, contentName, fileName) {
    this.analyticsService.tracDocumentsAttachmentViewByTypeLineMake(contentType, contentName, fileName);
  }
  analyticsCallExternalDocumentAttachmentTrack(contentType, contentName, fileName, userAddress, userCity, userState, userZipCode) {
    this.analyticsService.trackClicksByExternalLocationDocumentAttachment(contentType, contentName, fileName, userAddress, userCity, userState, userZipCode);
  }
  analyticsCallAdminDocumentAttachmenttrack(contentType, contentName, fileName, userid) {
    this.analyticsService.trackDocumentAttachmentClicksbyAdminUser(contentType, contentName, fileName, userid);
  }

  likeNoiseCatalog() {
    this.spinnerService.show('bmwSpinner');

    this.noiseCatalogService.posttNoiseCatalogLikes(this.username, this.currentNoiseCatalog.noiseCatalogId).subscribe(value => {

      if (value.hasOwnProperty('noiseCatalogDisplayId')) {
        this.currentNoiseCatalog = value;
        this.noisecatalogFile = this.vimeoBaseUrl + this.currentNoiseCatalog.noisecatalogFileName;
        this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.noisecatalogFile);
        this.toggleLikeOrDislikeNoiseCatalog("Liked");
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
        //Analytics Call
        this.analyticsService.trackRatingByTypeLineMake('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, 'rated');
      }
    }, error => this.spinnerService.hide('bmwSpinner'));
  }
  dislikeNoiseCatalog() {
    this.spinnerService.show('bmwSpinner');
    this.noiseCatalogService.posttNoiseCatalogDislikes(this.username, this.currentNoiseCatalog.noiseCatalogId).subscribe(value => {
      if (value.hasOwnProperty('noiseCatalogDisplayId')) {
        this.currentNoiseCatalog = value;
        this.noisecatalogFile = this.vimeoBaseUrl + this.currentNoiseCatalog.noisecatalogFileName;
        this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.noisecatalogFile);
        this.toggleLikeOrDislikeNoiseCatalog("Disliked");
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
        //Analytics Call
        this.analyticsService.trackRatingByTypeLineMake('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, 'rated');
      }
    }, error => this.spinnerService.hide('bmwSpinner'));
  }
  toggleAddToWatchlist() {
    let watchList;
    this.spinnerService.show('bmwSpinner');
    this.noiseCatalogService.toggleNoiseCatalogWatchlist(this.username, this.currentNoiseCatalog.noiseCatalogId).subscribe(data => {
      watchList = data;
      if (data) {
        this.isNoiseCatalogWatchlisted = !this.isNoiseCatalogWatchlisted;
        this.spinnerService.hide('bmwSpinner');
      }
      // this.isNoiseCatalogWatchlisted = watchList.some(noisecatalog => noisecatalog.noiseCatalogId === this.currentNoiseCatalog.noiseCatalogId);
    },
      error => this.spinnerService.hide('bmwSpinner')
    );
  }
  addNoiseCatalogToWatchlist() {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Noise Catalog', this.currentNoiseCatalog.noiseCatalogDisplayNumber, 'saved');
    //Analytics call
    this.noiseCatalogService.addNoiseCatalogToWatchlist(this.username, this.currentNoiseCatalog.noiseCatalogId).subscribe(data => {
      if (data) {
        this.toastService.success('Noise Catalog added to watchlist', 'Success', {
          closeButton: true,
          tapToDismiss: true,
          positionClass: 'toast-bottom-center',
          timeOut: 2000,
        });
      }
    });
  }
  toggleLikeOrDislikeNoiseCatalog(likedOrDisliked?: string) {
    this.likeOrDislikeNoiseCatalog = likedOrDisliked;
    // this.spinnerService.show('bmwSpinner');
    this.noiseCatalogLiked = false;
    this.noiseCatalogDisliked = false;
    this.noiseCatalogService.getUserNoiseCatalogLikesDislikes(this.username, this.currentNoiseCatalog.noiseCatalogId).subscribe(data => {
      // this.spinnerService.hide('bmwSpinner');
      this.likeOrDislikeNoiseCatalog = data['NoiseCatalogLikedOrDisliked'];
    });
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}

function filterNoiseCatalogArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.noiseCatalogList.length; i++) {
    // for (var j = 0; j < filter.length; j++) {
    if (array.noiseCatalogList[i].noiseCatalogId === filter) {
      myArrayFiltered.push(array.noiseCatalogList[i]);
      //}
    }
  }
  return myArrayFiltered;
}